import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import EnterpriseSettings from '../components/EnterpriseSettings'
import { getEnterpriseSettings, updateEnterpriseSetting, clearMessages } from '../actions/enterpriseSettingsActions'

const EnterpriseSettingsContainer = ({ settings, getEnterpriseSettings, updateEnterpriseSetting, clearMessages }) => {
  useEffect(() => {
    clearMessages()
    getEnterpriseSettings()
  }, [getEnterpriseSettings, clearMessages])

  const handleSubmit = (event, setting) => {
    event.preventDefault()
    updateEnterpriseSetting(setting)
  }

  if (settings.fetching || !settings.list) {
    return <LgyLoadingIcon />
  }
  return <div>
    <h2>Enterprise Settings</h2>
    {settings.success && <LgyAlertDialog type='success' heading='Update Successful' role='alert' text={`Successfully updated ${settings.name}`} />}
    <EnterpriseSettings settings={settings.list} handleSubmit={handleSubmit} />
  </div>
}

const mapStateToProps = (state) => ({
  settings: state.adminState.enterpriseSettings
})

const mapDispatchToProps = { getEnterpriseSettings, updateEnterpriseSetting, clearMessages }

export default connect(mapStateToProps, mapDispatchToProps)(EnterpriseSettingsContainer)
